import styled from "styled-components";

import HeroMockup, { useHeroMockupTilt } from "./HeroMockup";

import { cls } from "src/theme/colors";
import { Appleogo, GoogleplayLogo, OnestoreLogo } from "src/assets/svgs";
// 마이디 히어로와 같은 휴대폰 레이어 (아래 휴대폰 / 위 휴대폰). 화면은 실제 마이주식 캡처다.
import HeroBack from "src/assets/images/hero/mystock_back.png";
import HeroFront from "src/assets/images/hero/mystock_front.png";

// 소개 문구와 스토어 주소는 personalai.so 의 마이주식 소개 페이지와 같다.
function StockIntro() {
  const { mockupRef, handlePointerMove, handlePointerLeave } = useHeroMockupTilt();

  return (
    <S.Container onPointerMove={handlePointerMove} onPointerLeave={handlePointerLeave}>
      <S.Box>
        <S.Left>
          <S.SubText>같은 종목을 보는 사람들이 댓글로 답합니다</S.SubText>
          <S.MainText>
            내 매매 기록에서 시작되는
            <br />
            주식 커뮤니티, <S.Highlight>마이주식</S.Highlight>
          </S.MainText>
          <S.BtnBox>
            <S.AppDownloadBtn
              href="https://play.google.com/store/apps/details?id=com.personalai.mytalk"
              target="_blank"
              rel="noopener noreferrer"
            >
              <GoogleplayLogo />
              Google Play
            </S.AppDownloadBtn>
            <S.AppDownloadBtn
              href="https://apps.apple.com/kr/app/%EB%A7%88%EC%9D%B4%EC%A3%BC%EC%8B%9D/id6805333415"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Appleogo />
              App Store
            </S.AppDownloadBtn>
            <S.AppDownloadBtn
              href="https://m.onestore.co.kr/v2/ko-kr/app/0001009180"
              target="_blank"
              rel="noopener noreferrer"
            >
              <OnestoreLogo />
              ONE store
            </S.AppDownloadBtn>
          </S.BtnBox>
        </S.Left>
        <HeroMockup mockupRef={mockupRef} back={HeroBack} front={HeroFront} alt="마이주식 앱 화면" />
      </S.Box>
    </S.Container>
  );
}

export default StockIntro;

const S = {
  Container: styled.section`
    width: 100%;
    height: 903px;
    background-color: ${cls.white};
    display: flex;
    position: relative;
  `,
  Box: styled.div`
    width: calc(100% - 480px);
    margin: 0 240px;
    display: flex;
    align-items: center;
  `,
  Left: styled.div`
    display: flex;
    flex-direction: column;
  `,
  SubText: styled.p`
    font-size: 40px;
    letter-spacing: -0.92px;
    margin-bottom: 10px;
    white-space: nowrap;
  `,
  MainText: styled.h1`
    font-size: 60px;
    font-weight: 700;
    line-height: 80px;
    letter-spacing: -1.38px;
    white-space: nowrap;
  `,
  Highlight: styled.span`
    color: ${cls.stockBlue};
  `,
  BtnBox: styled.div`
    display: flex;
    margin-top: 80px;
  `,
  AppDownloadBtn: styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 220px;
    height: 80px;
    border-radius: 40px;
    color: #fff;
    font-size: 20px;
    font-weight: 700;
    letter-spacing: -0.2px;
    background: rgba(0, 0, 0, 0.8);
    margin-right: 20px;
    svg {
      margin-right: 8px;
    }
  `,
};
